"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

export function SplashScreen({ onComplete }: { onComplete: () => void }) {
  const [exit, setExit] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Start animation sequence immediately
    setMounted(true);
    
    const timer = setTimeout(() => {
      setExit(true);
      setTimeout(() => onComplete(), 500); // Quick handoff
    }, 2200); // Snappy display time

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cn(
      "fixed inset-0 z-[100] flex items-center justify-center bg-[#050505] overflow-hidden transition-all duration-700 ease-in-out",
      exit ? "opacity-0 pointer-events-none" : "opacity-100"
    )}>
      
      {/* Background Cinematic Flare */}
      <div className={cn(
        "absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.06)_0%,transparent_60%)] transition-transform duration-[3000ms] ease-out",
        mounted && !exit ? "scale-150 opacity-100" : "scale-100 opacity-0",
        exit && "scale-[1.8] opacity-0"
      )} />

      <div className="relative flex flex-col items-center gap-10">
        <div className={cn(
          "relative transition-all duration-[1500ms] cubic-bezier(0.22, 1, 0.36, 1)",
          mounted && !exit ? "scale-100 blur-0 opacity-100" : "scale-90 blur-2xl opacity-0",
          exit && "scale-105 blur-lg opacity-0"
        )}>
          {/* Logo with drop shadow glow */}
          <Image 
            src="/big_white_logo_osmose.png" 
            alt="Osmose Logo" 
            width={320} 
            height={320} 
            className="object-contain drop-shadow-[0_0_40px_rgba(255,255,255,0.15)]"
            priority
          />
        </div>
      </div>

      {/* Vignette effect */}
      <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_150px_rgba(0,0,0,0.8)]" />
    </div>
  );
}
